import { gql } from '@apollo/client';
import type { SharedDocument } from 'types/Document';
import {DOCUMENT_FRAGMENT} from './DocumentFragments';

export const GET_VISIBLE_DOCUMENTS_FROM_FOLDER_QUERY = gql`
  query GetVisibleDocumentsFromFolderQuery(
    $getVisibleDocumentsFromFolderInput: GetVisibleDocumentsFromFolderInput!
  ) {
    visibleDocumentsFromFolder(
      getVisibleDocumentsFromFolderInput: $getVisibleDocumentsFromFolderInput
    ) {
      documents {
        ...documentFields
      }
      errorReason
    }
  }
  ${DOCUMENT_FRAGMENT}
`;

export enum VisibleDocumentsFromFolderError {
  NOT_A_FOLDER = 'NOT_A_FOLDER',
  NOT_LINKED = 'NOT_LINKED',
  UNAUTHORIZED = 'UNAUTHORIZED',
  UNKNOWN_DOCUMENT = 'UNKNOWN_DOCUMENT',
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  WRONG_LINK = 'WRONG_LINK',
}

export type GetVisibleDocumentsFromFolderOutput = {
  visibleDocumentsFromFolder: {
    documents: SharedDocument[];
    errorReason: VisibleDocumentsFromFolderError;
  };
};
